'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voter-group-edit', {
      url: '/voter-group/edit/:id',
      template: '<voter-group-edit></voter-group-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/voter-group/voter-group-edit/voter-group-edit.routes.js